import { render, staticRenderFns } from "./ProductIntroRow.vue?vue&type=template&id=04d650c4&scoped=true"
import script from "./ProductIntroRow.vue?vue&type=script&lang=js"
export * from "./ProductIntroRow.vue?vue&type=script&lang=js"
import style0 from "./ProductIntroRow.vue?vue&type=style&index=0&id=04d650c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d650c4",
  null
  
)

export default component.exports